import { render, staticRenderFns } from "./DesgloseLibroDetalle.vue?vue&type=template&id=6e59364a"
import script from "./DesgloseLibroDetalle.vue?vue&type=script&lang=js"
export * from "./DesgloseLibroDetalle.vue?vue&type=script&lang=js"
import style0 from "./DesgloseLibroDetalle.vue?vue&type=style&index=0&id=6e59364a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports